var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    staticClass: "app--main"
  }, [_c('main-visual'), _c('section', [_c('v-sheet', {
    attrs: {
      "height": "32"
    }
  }, [_c('v-row', {
    staticClass: "h-100",
    attrs: {
      "no-gutters": "",
      "justify": "end",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('txt', {
    staticClass: "txt--sm txt--dark px-12px"
  }, [_vm._v("* 홈페이지의 이미지는 실제 조성 이미지가 아닌 이해를 돕기 위한 이미지 입니다.")])], 1)], 1)], 1)], 1), _c('main-section-primary', {
    staticClass: "main-section--sm"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('tit-tertiary', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" 인생의 터닝포인트를 잡다. "), _c('br'), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("세이지움 개봉")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('txt-primary', {
    staticClass: "line-height-15"
  }, [_c('div', [_vm._v("개봉역 역세권 청년안심주택 세이지움 개봉은 지하철 1호선 개봉역 역세권에 위치해 있으며 지하철 7호선 광명사거리역과 가까운 입지로 교통 생활 편의성이 뛰어난 청년안심 주택입니다.")]), _c('br'), _c('div', [_vm._v("서울시 구로구 내 처음 공급되는 청년안심주택으로, 입주민 편의를 위한 피트니스, 작은 도서관, 코인세탁실 등 대규모 커뮤니티 공간을 갖추고 있어 청년들의 소중한 시간을 지켜주고 여유 있는 라이프 스타일을 즐길 수 있습니다.")])])], 1)], 1)], 1), _c('main-section-primary', {
    staticClass: "main-section--sm main-section--special"
  }, [_c('v-row', {
    attrs: {
      "justify": "space-between",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5",
      "lg": "4",
      "xl": "3"
    }
  }, [_c('tit-wrap-primary', {
    attrs: {
      "titWrapSize": "tit-wrap--sm",
      "subTitSize": "tit--xxs",
      "subTitClass": "white--text",
      "titClass": "white--text font-weight-bold"
    },
    scopedSlots: _vm._u([{
      key: "TitAdd",
      fn: function () {
        return [_vm._v("SEIZIUM GAEBONG")];
      },
      proxy: true
    }])
  }, [_vm._v(" 개봉역 역세권"), _c('br'), _vm._v(" 청년안심주택"), _c('br'), _vm._v(" 세이지움 개봉 특장점 ")]), _c('txt-primary', {
    staticClass: "white--text"
  }, [_vm._v("서울 역세권에 위치하여 가까운 교통시설 이용과 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v("편리한 생활인프라를 가지고 있습니다.")]), _c('div', {
    staticClass: "btn-wrap justify-start"
  }, [_c('v-btn', {
    staticClass: "btn-special btn-special--01",
    attrs: {
      "tile": "",
      "outlined": "",
      "x-large": "",
      "width": "160",
      "href": "/business/overview",
      "color": "white"
    }
  }, [_vm._v("사업안내")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('v-img', {
    attrs: {
      "eager": "",
      "src": "/images/main/special.jpg"
    }
  })], 1)])], 1)], 1), _vm._l(_vm.items, function (item, index) {
    return [_c('main-section-primary', {
      key: index,
      staticClass: "main-section--sm main-section--list"
    }, [_c('v-row', {
      staticClass: "row--xxl",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "4",
        "order-md": index % 2 === 0 ? '2' : null
      }
    }, [_c('tit-wrap-primary', {
      attrs: {
        "titWrapSize": "tit-wrap--sm",
        "subTitSize": "tit--xxs",
        "subTitClass": "primary--text",
        "titClass": "font-weight-bold"
      },
      scopedSlots: _vm._u([{
        key: "TitAdd",
        fn: function () {
          return [_vm._v("PREMIUM 0" + _vm._s(index + 1))];
        },
        proxy: true
      }], null, true)
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    })]), _c('txt-primary', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })]), item.link ? [_c('div', {
      staticClass: "btn-wrap justify-start"
    }, [_c('v-btn', {
      staticClass: "btn-special btn-special--02",
      attrs: {
        "tile": "",
        "outlined": "",
        "x-large": "",
        "width": "160",
        "to": item.link
      }
    }, [_vm._v("더보기")])], 1)] : _vm._e()], 2), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "8",
        "data-aos": index % 2 === 0 ? 'fade-right' : 'fade-left',
        "data-aos-delay": "100"
      }
    }, [_c('div', {
      staticClass: "image-wrap"
    }, [_c('v-img', {
      attrs: {
        "eager": "",
        "max-width": "952",
        "src": item.image
      }
    }, [item.imageText ? [_c('v-sheet', {
      staticClass: "d-flex justify-center align-center pa-12px",
      attrs: {
        "color": "rgba(0,0,0,0.6)",
        "width": "100%",
        "height": "100%"
      }
    }, [_c('tit', {
      staticClass: "tit--lg white--text text-center"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.imageText)
      }
    })])], 1)] : _vm._e()], 2)], 1)])], 1)], 1)];
  }), _c('main-section-primary', {
    staticClass: "main-section--sm main-section--contact"
  }, [_c('tit-wrap-primary', {
    attrs: {
      "titWrapSize": "tit-wrap--sm",
      "titWrapClass": "text-center",
      "subTitSize": "tit--xxs",
      "subTitClass": "primary--text",
      "titSize": "tit--lg",
      "titClass": "font-weight-regular white--text",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    },
    scopedSlots: _vm._u([{
      key: "TitAdd",
      fn: function () {
        return [_vm._v("CONTACT US")];
      },
      proxy: true
    }])
  }, [_vm._v(" 인생의 터닝포인트를 잡다."), _c('br'), _vm._v(" 개봉역 역세권 청년안심주택"), _c('br'), _vm._v(" 세이지움 개봉 ")]), _c('div', {
    staticClass: "d-flex justify-center"
  }, [_c('v-btn', {
    attrs: {
      "tile": "",
      "color": "primary",
      "x-large": "",
      "width": "160",
      "to": "/application"
    }
  }, [_vm._v("청약 신청")])], 1)], 1), _c('popup-layer')], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }